// ============================================================
// Tie-In — triageApi.js
// All API calls for the triage frontend.
// Gets auth token directly from Supabase session.
// ============================================================

import { createClient } from '@supabase/supabase-js';

const BASE = import.meta.env.VITE_API_URL || '';

const supabase = createClient(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_ANON_KEY
);

async function authHeaders() {
  const { data: { session } } = await supabase.auth.getSession();
  const token = session?.access_token || '';
  return {
    'Content-Type':  'application/json',
    'Authorization': `Bearer ${token}`,
  };
}

async function request(method, path, body = null) {
  const headers = await authHeaders();
  const opts    = { method, headers };
  if (body) opts.body = JSON.stringify(body);

  const res = await fetch(`${BASE}${path}`, opts);
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: 'Request failed' }));
    throw new Error(err.error || `HTTP ${res.status}`);
  }
  if (res.status === 204) return null;
  return res.json();
}

// ── Config ────────────────────────────────────────────────────
export const getConfig    = (userId)          => request('GET', `/api/triage/config/${userId}`);
export const updateConfig = (userId, updates) => request('PUT', `/api/triage/config/${userId}`, updates);

// ── Onboarding ────────────────────────────────────────────────
export const getQuestions     = ()               => request('GET',  '/api/triage/questions');
export const submitOnboarding = (userId, answers) => request('POST', `/api/triage/onboarding/${userId}`, { answers });

// ── History ───────────────────────────────────────────────────
export const getHistory = (userId, page = 1, limit = 20) =>
  request('GET', `/api/triage/history/${userId}?page=${page}&limit=${limit}`);

// ── Manual run ────────────────────────────────────────────────
export const triggerRun = (userId) => request('POST', `/api/triage/run/${userId}`);

// ── Label provisioning ────────────────────────────────────────
export const provisionLabels = (userId) => request('POST', `/api/gmail/labels/provision/${userId}`);

// ── Admin ─────────────────────────────────────────────────────
export const getAdminUsers      = ()                    => request('GET', '/api/triage/admin/users');
export const getAdminStats      = ()                    => request('GET', '/api/triage/admin/stats');
export const getAdminErrors     = ()                    => request('GET', '/api/triage/admin/errors');
export const updateUserSecurity = (userId, updates)     => request('PUT', `/api/triage/admin/users/${userId}/security`, updates);
